import React from "react";
import './style.less'
import { Row, Col, Image } from 'antd'
export default class HowToBuy extends React.Component {
    render() {
        const gutter = {
            xs: 8, sm: 16, md: 24, lg: 32
        }
        const list = [
            {
                key: 1,
                bgSrc: "http://qiniu.metridynamic.com/image/new-official-en/insurance/1.png",
                desc: "联系我们的销售获取保险计划"
            },
            {
                key: 2,
                bgSrc: "http://qiniu.metridynamic.com/image/new-official-en/insurance/2.png",
                desc: "提供保险信息，确认保额，支付保费"
            },
            {
                key: 3,
                bgSrc: "http://qiniu.metridynamic.com/image/new-official-en/insurance/3.png",
                desc: "保险公司审阅，之后录入系统"
            },
            {
                key: 4,
                bgSrc: "http://qiniu.metridynamic.com/image/new-official-en/insurance/4.png",
                desc: "保单生成，保险生效"
            },
            {
                key: 5,
                bgSrc: "http://qiniu.metridynamic.com/image/new-official-en/insurance/5.png",
                desc: "保险完成并获得凭证"
            },
        ]
        return (
            <div className={'how-to-buy'}>
                <h1>如何购买？</h1>
                <div className={'buy-process'}>
                    <Row justify="center" style={{ width: '100%' }}>
                        {
                            list.map(item => {
                                return <Col className="col-item" xs={24} sm={24} md={12} lg={8} xl={8} xxl={8}>
                                    <div className="item-box">
                                        <div className="num">{item.key}</div>
                                        <div className="icon-img">
                                            <Image preview={false} src={item.bgSrc} />
                                        </div>
                                        <p>{item.desc}</p>
                                    </div>
                                </Col>
                            })
                        }
                    </Row>
                </div>
            </div>
        )
    }
}
